import React from "react";
import "./StyleLoadingDottedButton.css";

function LoadingDottedButton({ btnText }) {
  return (
    <div className="justify-content-center d-flex">
      <div
        className="opacity-0 "
        style={{ width: "1px", whiteSpace: "nowrap" }}
      >
        {btnText}
      </div>

      <div className="loading-dots">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default LoadingDottedButton;
